import { PAGE_KEY } from './constants';

export const es = {
  [PAGE_KEY]: {
    TITLE: 'Cobertura de sucesión',
    DESCRIPTION:
      'Monitorea qué cargos cuentan con sucesores identificados y detecta riesgos en la continuidad del talento para asegurar la estabilidad y sostenibilidad del liderazgo en la organización',
    PERFORMANCE: 'Desempeño',
    SUCCESSION_COVERAGE: 'Cobertura de sucesión',
    TABLE_TITLE: 'Cargos',
    SEARCH_PLACEHOLDER: 'Buscar cargos',
    CRITICALITY_HIGH: 'Alta',
    CRITICALITY_MEDIUM: 'Media',
    CRITICALITY_LOW: 'Baja',
    SUCCESSOR_COVERED: 'Cubierta',
    SUCCESSOR_NO_SUCCESSOR: 'Sin sucesor',
    AI_SUGGESTIONS_TOOLTIP:
      'Candidatos identificados por IA: Este cargo tiene sugerencias generadas según el perfil del cargo y los criterios definidos.',
    HIGH_RISK_TOOLTIP:
      'Riesgo alto: Este cargo es de alta criticidad y actualmente no cuenta con sucesor confirmado ni candidatos identificados. Se recomienda priorizar su cobertura.',
    COLUMN_POSITION: 'Cargo',
    COLUMN_CRITICALITY: 'Criticidad',
    COLUMN_SUGGESTED_CANDIDATES: 'Candidatos sugeridos',
    COLUMN_CONFIRMED_SUCCESSOR: 'Sucesor confirmado',
    TOOLTIP_VIEW_POSITION_DETAIL: 'Ver detalle del cargo',
    ALERT_SELECTED_RECORD: 'Registro seleccionado: {{id}}',
    ERROR_TITLE: 'Ocurrió un error en la carga',
    ERROR_DESCRIPTION: 'Haz clic en el botón para intentar cargar nuevamente.',
    ERROR_RETRY_BUTTON: 'Reintentar',
    TOTAL_COVERAGE_TITLE: 'Cobertura total de sucesión',
    COVERED_POSITIONS: 'cargos cubiertos',
    PRIORITY_HIGH: 'Alta',
    PRIORITY_MEDIUM: 'Media',
    PRIORITY_LOW: 'Baja',
    POSITIONS_WITHOUT_COVERAGE: 'Cargos sin cobertura',
    POSITIONS_COUNT: 'cargos',
    VIEW_POSITIONS_AT_RISK: 'Ver cargos en riesgo',
    LAST_UPDATE: 'Última actualización el',
    POSITIONS_WITH_CONFIRMED_SUCCESSOR: 'Cargos con sucesor confirmado',
    VIEW_COVERED_POSITIONS: 'Ver cargos cubiertos',
    OF: 'de',
    EMPTY_TABLE_TITLE: 'No hay cargos disponibles',
    EMPTY_TABLE_SUBTITLE:
      'No se encontraron cargos que coincidan con tu búsqueda.',
  },
};
